import { addDays } from "date-fns";

export const checkDebtWillExpireDays = (item, days, exibirPagos=false) => {
  let currentDate = new Date().setUTCHours(0,0,0,0);;
  let expiryDate = new Date(item.DataVencimento).setUTCHours(0,0,0,0);
  let expiryRangeAlertDate = addDays(new Date(), days);

  if (
    currentDate <= expiryDate &&
    expiryDate <= expiryRangeAlertDate
  ) {
    return true;
  }

  return false;
};
